<template>
  <div id="curveDetail">
    <el-row>
      <div class="curve_desc">
        <span>curveNumber：{{ basicinfo.curveNumber }}</span>
        <!-- <span class="fontStyle2" /> -->
        <span>capacity：{{ basicinfo.capacity }} </span>
        <!-- <span class="fontStyle2" /> -->
        <span>battery：{{ basicinfo.battery }} </span>
        <!-- <span class="fontStyle2" /> -->
        <span>manufacturer：{{ basicinfo.manufacturer }}</span>
        <!-- <span class="fontStyle2" /> -->
        <span>descriptions：{{ basicinfo.descriptions }}</span>
      </div>
    </el-row>

    <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card">
      <el-tab-pane v-for="(item,index) in modelList" :key="index" :label="item.name" :name="item.name">
        <div>
          <div v-if="!item.data">{{ $t('yhubReport.Nodata') }}</div>
          <div v-else>
            <curveDetailTem :form-data="item.data" />
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { getCurveNumberInfoById } from '@/api/settingBattery'
import curveDetailTem from '@/views/setting/curve/curveDetailTem'

export default {
  props: ['row'],
  components: {
    curveDetailTem
  },
  data () {
    return {
      basicinfo: {},
      dataModel: {},
      activeName: '',
      modelList: []
    }
  },
  computed: {
    id () {
      return this.$route.query.id
    }
  },
  mounted () {
    console.log(this.row)
    this.queryList()
  },
  methods: {
    queryList () {
      getCurveNumberInfoById({ id: this.row.id || this.id }).then(res => {
        console.log('曲线数据：', res)
        if (res.resultCode == 1001) {
          this.basicinfo = res.resultModel
          const keys = Object.keys(res.resultModel)
          keys.forEach(item => {
            if (/^g/.test(item)) {
              // console.log(item)
              if (this.basicinfo[item] && item.indexOf('Dc') < 0) {
                this.modelList.push({
                  name: item,
                  data: this.basicinfo[item + 'Dc']
                })
              }
            }
          })
          if (this.modelList.length) {
            this.activeName = this.modelList[0].name
          }
        }
      })
    }
  }
}
</script>
<style lang="scss">
.curve_desc {
  span {
    font-size: 18px;
    margin-right: 20px;
  }
}
</style>
